import { useMutation } from "@tanstack/react-query";
import { getAudioApiClient } from "@shared/apis/sidekick/api-factories";

export const useTranscribeAudio = () => {
  const audioApi = getAudioApiClient();
  return useMutation({
    mutationFn: async ({ audio }: { audio: File }) => {
      const response = await audioApi.audioControllerTranscribeAudio({
        audio,
      });
      return response.text;
    },
  });
};
